export type ContentPreview = {
  title: string
  count: string
  image: string
  alt: string
  bullets: string[]
}

export const previews: ContentPreview[] = [
  {
    title: 'Baby Fútbol',
    count: '25 ejercicios',
    image:
      'https://cdn.magicpatterns.com/uploads/u9nfya72jKV7pdrCoNP9nt/ChatGPT_Image_19_ago_2026,_05_07_34_p.m..png',
    alt: 'Plantilla de 25 ejercicios para baby fútbol con diagramas, objetivo, desarrollo y variante de cada ejercicio',
    bullets: [
      'La Serpiente, El Tren del Gol, El Semáforo, Bomberitos y 21 más',
      'Objetivo, desarrollo y variante escritos en cada ejercicio',
      'Simbología y edades orientativas de 4 a 9 años',
    ],
  },
  {
    title: 'Fútbol 11 · Táctico',
    count: '20 ejercicios',
    image:
      'https://cdn.magicpatterns.com/uploads/x8uKUWdJafLWFrZkFkNp2K/ChatGPT_Image_19_ago_2026,_05_07_37_p.m..png',
    alt: 'Plantilla de 20 ejercicios de fútbol 11 con canchas dibujadas, presión, transiciones y balón parado',
    bullets: [
      'Salida progresiva, presión alta, tercer hombre y balón parado',
      'Organización exacta: 11v11, 8v6, 7v3, con y sin arqueros',
      'Variaciones para subir o bajar la dificultad en el momento',
    ],
  },
  {
    title: 'Fútbol 11 · Juego posicional',
    count: '20 ejercicios',
    image:
      'https://cdn.magicpatterns.com/uploads/hkxLLSqrWGJDnGezc2Aqo2/ChatGPT_Image_19_ago_2026,_05_07_39_p.m..png',
    alt: 'Plantilla de 20 ejercicios de fútbol 11 de juego posicional, posesión, progresión por bandas y finalización',
    bullets: [
      'Posesión, rondos por zonas y progresión por bandas',
      'Ataque organizado, coberturas y juego aéreo en las dos áreas',
      'Recomendaciones generales para dirigir cada práctica',
    ],
  },
]
